import {Loading} from '../../constants/actionType';

const initialState = {
  show: false,
  text: '',
};

export default function loadingState(state = initialState, action = {}) {
  switch (action.type) {
    case Loading.SHOW:
      return {...action.loading};
    case Loading.HIDE:
      return {show: false, text: ''};
    case Loading.CHANGE_TEXT:
      return {...state, text: action.text};
    default:
      return state;
  }
}
